import React from 'react';
import {
  Col,
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';

export const Label = (props) => <FormGroup>
  {props.horizontal || !props.vertical ?
    <div>
      <Col
        componentClass={ControlLabel}
        className={`form-label ${props.labelClassName || ''}`}
        sm={props.sm ? props.sm : props.xs || 3}
        xs={props.xs}
        style={props.style}
      >
        {props.label}
      </Col>
      <Col
        // eslint-disable-next-line
        sm={props.sm ? 12 - props.sm : (props.xs ? 12- props.xs : 9)}
        xs={props.xs ? 12 - props.xs : undefined} style={props.childStyle}
      >
        {props.children}
      </Col>
    </div>
    : ''}
  {props.vertical ?
    <Col xs={12} style={props.style}>
      <div style={props.labelStyle} className={`form-label ${props.labelClassName || ''}`}>
        {props.label}
      </div>
      <div style={props.childStyle}>
        {props.children}
      </div>
    </Col>
    : ''}
</FormGroup>;

Label.propTypes = {
  children: React.PropTypes.oneOfType([
    React.PropTypes.arrayOf(React.PropTypes.node),
    React.PropTypes.node,
  ]),
  label: React.PropTypes.string,
  labelClassName: React.PropTypes.string,
  style: React.PropTypes.object,
  labelStyle: React.PropTypes.object,
  childStyle: React.PropTypes.object,
  horizontal: React.PropTypes.bool,
  vertical: React.PropTypes.bool,
  sm: React.PropTypes.number,
  xs: React.PropTypes.number,
};

export default Label;
